<template>
  <el-dialog
    class="rc-dialog"
    title="上传附件"
    :visible.sync="CUFlagDialog"
    @close="closeDialog"
    width="45%"
  >
    <el-form
      ref="curdForm"
      size="small"
      label-position="right"
      label-width="100px"
    >
      <el-form-item
        required
        label="附件："
        error="请上传附件"
        :show-message="attachmentList.length === 0"
      >
        <upload
          :limit="50"
          :path="'class/attachment'"
          v-model="attachmentList"
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click="closeDialog" title="取消"></butn>
      <butn btntype="primary" @click="createData" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import vue from "@/main";
import { fileLibraryUpload } from "@/api/fileLibrary";
import Upload from "@/components/upload/index";
export default {
  components: { butn, Upload },
  props: {
    classId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      CUFlagDialog: false,
      attachmentList: [],

      // classId: "",
    };
  },
  created() {
    // vue.$on("uploadFile", (item) => {
    //   this.$nextTick(() => {
    //     this.CUFlag = true;
    //     this.classId = item;
    //   });
    // });
  },
  methods: {
    createData() {
      if (this.attachmentList.length > 0) {
        this.loading = true;
        let params = {
          classId: this.classId,
          bizType: 1,
        };
        params["attachment"] = JSON.stringify(this.attachmentList);
        fileLibraryUpload(params).then((res) => {
          this.loading = false;
          if (res && res.code == 0) {
            this.$message.success(res.msg);
            vue.$emit("tableInit");
            this.closeDialog();
          }
        });
      }
    },
    closeDialog() {
      this.CUFlagDialog = false;
      // 数据重置
      this.attachmentList = [];
    },
  },
  // beforeDestroy() {
  //   vue.$off("uploadFile");
  //   this.CUFlag = false;
  // },
};
</script>

<style lang="scss" scoped></style>
